export const GRADIENT_MODES = {
  DEGRADATION_LEVEL: "degradation_level",
  ANGLE_VERTICAL: "angle_vertical",
  ANGLE_HORIZONTAL: "angle_horizontal",
  GAP_WIDTH_MEAN: "gap_width_mean",
  GAP_WIDTH_MAX: "gap_width_max",
  OVALITY_MEAN: "ovality_mean",
  OVALITY_MAX: "ovality_max",
  HORIZONTAL_OUT_OF_STRAIGHT: "horizontal_out_of_straight",
  VERTICAL_OUT_OF_STRAIGHT: "vertical_out_of_straight",
  REMAINING_MEAN: "remaining_mean",
  REMAINING_MIN: "remaining_min",
  REMAINING_MAX: "remaining_max",
  REMAINING_STD: "remaining_std",
  DEGRADATED_TOTAL_MEAN: "degradated_total_mean",
  DEGRADATED_TOTAL_MIN: "degradated_total_min",
  DEGRADATED_TOTAL_MAX: "degradated_total_max",
  DEGRADATED_TOTAL_STD: "degradated_total_std",
  MATERIAL: "material",
  JOINT_TYPE: "joint_type",
  QUALITY: "quality",
  QUALITY_ANOMALY: "quality_anomaly",
  CORROSION_PRODUCT_PERC: "corrosion_product_perc",
  DIAMETER_CLASS: "diameter_class",
  WALL_THICKNESS_ORIGINAL: "wall_thickness_original",
  REMAINING_LIFE: "remaining_life_calculation.remaining_life",
  REMAINING_LIFE_GROUP: "remaining_life_calculation.remaining_life_group",
  ROAD_TYPE: "remaining_life_calculation.road_type",
  SOIL_TYPE: "remaining_life_calculation.soil_type",
  ROAD_DISTANCE: "remaining_life_calculation.road_distance",
  DEGRADATION_RATE: "remaining_life_calculation.degradation_rate",
  GROUND_WATER_LEVEL: "remaining_life_calculation.ground_water_level",
  WIRE_BREAKS: "wire_breaks",
} as const;

export const MIN_GRADIENT_VALUE_OF_MAX_VALUE_OF_OVALITY = 8;
